import * as React from 'react';
import {YearMonth} from "./utils/YearMonthRangePicker";
import furoApi from "../api/FuroApi";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import {ErrorResponse, User} from "../api/dtos/dtos";
import {ErrorAlert} from "../common/ErrorAlert";
import './utils/Statistics.css';
import {CategoryValue, StatisticsRequest} from "../api/dtos/statistics";
import CategoryDistributionStatisticsPanel from "./CategoryDistributionStatisticsPanel";
import {RouteComponentProps} from "react-router";


interface State {
  costStatistics?: CategoryValue[];
  usageStatistics?: CategoryValue[];
  users?: User[];
  error?: ErrorResponse;
}

class OverallStatisticsPage extends React.Component<{}, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {
      users: [],
    };
  }

  public componentDidMount() {
    this.loadUsers();
  }

  public render(): React.ReactNode {
    const {costStatistics, usageStatistics, error} = this.state;
    const {users} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <CategoryDistributionStatisticsPanel
          users={users?.map(user => user.userName!)}
          onQueryParamsChange={this.onQueryParamsChange}
          costStatistics={costStatistics}
          usageStatistics={usageStatistics}
        />

        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }

  private loadUsers = () => {
    const promise = furoApi.users.getUsers()
      .then(response => {
        this.setState({
          users: response,
          error: undefined,
        });
      })
      .catch((error: ErrorResponse) => {
        this.setState({error});
      });
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onQueryParamsChange = (start: YearMonth, end: YearMonth, responsibleUser?: string) => {
    const request: StatisticsRequest = {
      startYear: start.year,
      startMonth: start.month,
      endYear: end.year,
      endMonth: end.month,
      responsibleUser,
    };
    this.loadStatisticsInRange(request);
  };

  private loadStatisticsInRange = (request: StatisticsRequest) => {
    const promise = furoApi.statistics.getOverallStatistics(request)
      .then(response => this.setState({
        costStatistics: response.categoryCostStatistics,
        usageStatistics: response.categoryUsageStatistics,
        error: undefined,
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default OverallStatisticsPage;


// WEBPACK FOOTER //
// ./src/statistics/OverallStatisticsPage.tsx